import { readCommunityPurpose } from "./communityParticipation";
import type { CommunityBoardFeedSort } from "./communityBoardFeed";

const sorts: CommunityBoardFeedSort[] = ["recent", "popular", "hits", "likes"];

function positiveId(value: string | null): number | "" {
  if (!value) return "";
  const id = Number(value);
  return Number.isSafeInteger(id) && id > 0 ? id : "";
}

/** The URL is the single source of truth, including browser back/forward. */
export function readBoardFilters(params: URLSearchParams) {
  const candidate = params.get("sort") as CommunityBoardFeedSort;
  return {
    news:
      params.get("news") === "only"
        ? ("only" as const)
        : params.get("news") === "exclude"
          ? ("exclude" as const)
          : ("" as const),
    purpose: readCommunityPurpose(params.get("purpose")),
    unanswered: params.get("unanswered") === "1",
    categoryId: positiveId(params.get("category_id")),
    subcategoryId: positiveId(params.get("subcategory_id")),
    author: positiveId(params.get("author")),
    sort: sorts.includes(candidate)
      ? candidate
      : ("recent" as CommunityBoardFeedSort),
    q: (params.get("q") || "").trim(),
    tag: (params.get("tag") || "").trim(),
  };
}

export function mergeUniqueItems<T>(
  previous: T[],
  next: T[],
  key: (item: T) => string,
): T[] {
  const seen = new Set(previous.map(key));
  return [
    ...previous,
    ...next.filter((item) => {
      const value = key(item);
      if (seen.has(value)) return false;
      seen.add(value);
      return true;
    }),
  ];
}

export function hasReadCommunityPost(id: number): boolean {
  try {
    return localStorage.getItem(`community-read-${id}`) === "1";
  } catch {
    return false;
  }
}

export function markCommunityPostRead(id: number): void {
  try {
    localStorage.setItem(`community-read-${id}`, "1");
  } catch {
    /* Reading works with storage disabled. */
  }
}
